import { OperatorForm } from "./operator.schema";
import { useFormContext } from "react-hook-form";
import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { ComboboxMultiYachtLabels } from "@/src/components/ui/combobox-multi-yacht-labels";
import { YachtLabel } from "@/src/app/Yachts/EditYacht/model";
import { useFactoryDialog } from "@/src/lib/useFactoryDialog";
import { AddLabelDialog } from "@/src/app/Yachts/EditYacht/AddLabelDialog";
import { fetch } from "@/src/lib/fetch";

export function YachtsLabels() {
  const [AddLabelDialogProps, addLabelDialogTrigger] = useFactoryDialog<YachtLabel>();

  return (
    <div className="grid gap-4 max-w-[1016px] grid-cols-[repeat(auto-fit,minmax(150px,328px))]">
      <h3 className="text-lg font-semibold col-span-full">Yacht labels</h3>
      <div className="w-full flex flex-col gap-1">
        <div>
          <FormField<OperatorForm, `labels`>
            name="labels"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Yacht Labels</FormLabel>
                <FormControl>
                  <ComboboxMultiYachtLabels<YachtLabel>
                    className="w-full"
                    onAddOption={addLabelDialogTrigger}
                    loadOptions={(query) => {
                      const data = fetch<{ data: YachtLabel[]; success: boolean }>(
                        `/api/yachts/labels${query ? `?query=${query}` : ""}`,
                      ).then((r: any) =>
                        r.data?.map((y: YachtLabel) => {
                          return {
                            value: y.value,
                            label: y.value,
                          };
                        }),
                      );
                      return data;
                    }}
                    placeholder="Search for label..."
                    value={(field.value ?? []).map((l) => l.value)}
                    onChange={(selectedValues: string[]) => {
                      const fullObjects = selectedValues.map((val) => {
                        const existing = (field.value ?? []).find((v) => v.value === val);
                        return existing ?? { value: val, id: crypto.randomUUID() };
                      });
                      field.onChange(fullObjects);
                    }}
                  />
                </FormControl>
                <AddLabelDialog {...AddLabelDialogProps} />
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
}
